var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinistar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47 14.256H8.226C8.352 13.482 8.694 12.636 9.27 11.718C10.422 9.9 12.744 8.118 14.742 7.704V6.948C13.752 6.732 12.78 6.282 11.844 5.616C9.936 4.266 8.532 2.25 8.226 0.432H7.47C7.29 1.386 6.876 2.304 6.228 3.24C4.95 5.094 2.952 6.462 0.918 6.948V7.704C1.944 7.92 2.988 8.424 4.014 9.198C6.102 10.764 7.2 12.708 7.47 14.256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinistar);
export default __webpack_public_path__ + "static/media/ministar.c89c9cc7ec0ddec6548f28231188f4af.svg";
export { ForwardRef as ReactComponent };